import { Transaction } from './plaidService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://wealthplayrepo.onrender.com/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : '',
  };
};

export const fetchTransactions = async (): Promise<Transaction[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/plaid/transactions`);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.transactions || [];
  } catch (error) {
    console.error('Error fetching transactions:', error);
    throw error;
  }
};

export const createManualTransaction = async (
  amount: number,
  category: string,
  name?: string
): Promise<Transaction> => {
  try {
    console.log('Creating manual transaction:', { amount, category, name });
    const response = await fetch(`${API_BASE_URL}/transactions/manual`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        amount,
        category,
        name: name || 'Manual Expense',
        date: new Date().toISOString(),
      }),
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('Error response:', errorData);
      throw new Error(`HTTP error! Status: ${response.status}, Message: ${JSON.stringify(errorData)}`);
    }

    const data = await response.json();
    console.log('Transaction created successfully:', data);
    return data;
  } catch (error) {
    console.error('Error creating manual transaction:', error);
    throw error;
  }
};

export const fetchManualTransactions = async (): Promise<Transaction[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/transactions/manual`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching manual transactions:', error);
    throw error;
  }
};

export const deleteManualTransaction = async (id: number): Promise<void> => {
  try {
    const response = await fetch(`${API_BASE_URL}/transactions/manual/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error deleting manual transaction:', error);
    throw error;
  }
}; 